import React from 'react';
import OnboardingLayout from './OnboardingLayout';
import OnboardingStep5 from './step5';

export default class OnboardingStep5Page extends React.Component {
    render() {
        return (
            <OnboardingLayout currentStep={5} totalSteps={5}>
                <OnboardingStep5 />
            </OnboardingLayout>
        );
    }
}
